import { Component } from '@angular/core';

@Component({
    selector: 'app-vehicles',
    templateUrl: './vehicles.component.html',
    styleUrls: ['./vehicles.component.scss'],
    standalone: false
})
export class VehiclesComponent {}
